export const ScreenWrapper = ({ children }) => {
    return (
        <div className="screen-wrapper">
            { children }
        </div>
    )
}